import type { ParsedGame } from "@onchainreps/chess";

interface OpeningPanelProps {
  game: ParsedGame;
}

export function OpeningPanel({ game }: OpeningPanelProps) {
  const opening = game.opening ?? game.headers.Opening ?? "Unknown opening";
  const eco = game.eco ?? game.headers.ECO;
  const variation = game.headers.Variation;
  const firstMoves = game.moves.slice(0, 8);

  return (
    <div>
      <h2 className="opening__name">{opening}</h2>
      <div className="opening__meta">
        {eco ? <span className="tag">{eco}</span> : null}
        {variation ? <span className="tag">{variation}</span> : null}
        {game.result ? <span className="tag">{game.result}</span> : null}
        {game.headers.TimeControl ? <span className="tag">{game.headers.TimeControl}</span> : null}
        {game.headers.Date ? <span className="tag">{game.headers.Date}</span> : null}
      </div>

      <div className="opening__moves">
        {firstMoves.map((move) => (
          <span className="opening__move" key={move.ply}>
            {move.color === "white" ? `${move.moveNumber}.` : ""}
            {move.san}
          </span>
        ))}
      </div>

      <p className="planned__desc" style={{ marginTop: "var(--space-5)" }}>
        Opening names come from the Creative Commons zero dataset curated by Lichess. Course lines with
        spaced-repetition drills arrive with the opening trainer.
      </p>
    </div>
  );
}
